import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { MIN_WIDTH } from 'utils/constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.greyBg};
  min-height: 100%;
`;

export const SecondaryNavigation = styled.div`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.grey3};
  padding: 0 32px;
  background-color: ${colors.white};
  z-index: 1;
`;
export const LeftWrapper = styled.div``;
export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  ovarflow: auto;
`;

export const Content = styled.div`
  width: ${MIN_WIDTH};
  margin: 28px auto;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};
  padding: 0 32px;
  display: flex;
  flex-direction: column;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
